import store from '@/store'
import QuizStatuses from '@/constants/QuizStatuses'
import storage from '@/services/storage'
import EventBus from '@/eventBus'

let preQuestionTimeout
let showQuestionTimeout
let showResultTimeout

function _switchQuizScreen(quizStatus) {
  store.dispatch('updateSlide', {
    quizStatus,
  })
}

function _isAudienceFormShowing() {
  if (store.state.presentation.teamPlay) {
    return (
      !store.state.audienceName ||
      !store.state.isAudienceEmojiDisabled ||
      !store.state.audienceQuizTeam
    )
  }
  return (
    !store.state.audienceName ||
    !store.state.isAudienceEmojiDisabled
  )
}

function clearSelfPaceTimeouts() {
  if (preQuestionTimeout) {
    window.clearTimeout(preQuestionTimeout)
  }
  if (showQuestionTimeout) {
    window.clearTimeout(showQuestionTimeout)
  }
  if (showResultTimeout) {
    window.clearTimeout(showResultTimeout)
  }
}

function _isQuizAnswered(presentation, slide) {
  const answeredSlideIds = storage.getValueByPresentation(presentation.id, 'answeredSlideIds', [])
  return answeredSlideIds.includes(slide.id)
}

function _setupQuizCountdownTimer(slide) {
  store.state.slide.quizTimestamp = [new Date().getTime()]
  store.state.countdownTimeToAnswer = slide.timeToAnswer
}

function _showSelfPacedQuestion(presentation, slide) {
  _switchQuizScreen(QuizStatuses.QUESTION_SCREEN)

  _setupQuizCountdownTimer(slide)

  // Wait for the question countdown timer to show result
  showResultTimeout = window.setTimeout(() => {
    _switchQuizScreen(QuizStatuses.RESULT_SCREEN)
    // If not answer, emit the quizTimeout event to call /api/answer/create
    if (!_isQuizAnswered(presentation, slide)) {
      setTimeout(() => {
        EventBus.$emit('quizTimeout')
      }, 500)
    }
  }, slide.timeToAnswer * 1000 + 500)
}

function _prepareToShowQuestion(presentation, slide) {
  // Wait for 3s before showing the question
  preQuestionTimeout = window.setTimeout(() => {
    if (presentation.enableQuizCoundown) {
      _switchQuizScreen(QuizStatuses.COUNTDOWN_5S_SCREEN)
      EventBus.$emit('startQuizScreenTwo')
      showQuestionTimeout = window.setTimeout(() => {
        _showSelfPacedQuestion(presentation, slide)
      }, 5e3)
    } else {
      _showSelfPacedQuestion(presentation, slide)
    }
  }, 3e3)
}

function playSelfPacedQuizSlide(presentation, slide) {
  clearSelfPaceTimeouts()

  // If the presentation not enable Self-paced mode,
  // or not join presentation,
  // or not quiz slide, skip
  if (
    _isAudienceFormShowing() ||
    !presentation.audiencePacing ||
    slide.type !== 'pickAnswer'
  ) {
    return
  }

  _switchQuizScreen(QuizStatuses.RULE_SCREEN)

  if (_isQuizAnswered(presentation, slide)) {
    _switchQuizScreen(QuizStatuses.RESULT_SCREEN)
  } else {
    _prepareToShowQuestion(presentation, slide)
  }
}

export default {
  playSelfPacedQuizSlide,
  clearSelfPaceTimeouts,
}
